module.exports = __webpack_public_path__ + "img/d9e3b1f.jpg";